module.exports = __webpack_public_path__ + "static/img/63.317bc09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/63.png
// module id = guGc
// module chunks = 0